import React from 'react';
import { Link } from 'react-router-dom';

const MerchantTermsAndConditionsDetails = () => {
  return (
    <>
      <section className='support-content ptb-120'>
        <div className='container'>
          <div className='row justify-content-between'>
            <div className='col-lg-12 col-md-8 p-lg-5'>
              <div className='support-article-wrap text-center'>
                <h1 className='display-5 mb-4 fw-bold'>
                  Merchant Terms & Conditions
                </h1>

                <div className='job-details-info my-5'>
                  <h3 className='h5'>
                    Version 1.0, 12 August 2024
                  </h3>
                </div>
              </div>
              <div className='support-article-wrap'>
                    <h4 className='h5 padding-top-5 padding-bottom-4'>
                      1. Introduction
                    </h4>
                    <p>
                      These Terms outline the relations between Sunlex, a company registered in Bulgaria, under company number 204749821, with address at Sofia, Bulgaria, (hereinafter "Sunlex", "Us", "We") and the Merchant who desire to use the AIS or PIS (as defined below) application form through Sunlex's website or otherwise using Sunlex technical solutions (the "Merchant", "You").
                    </p>
                    <p>
                      Sunlex performs technical facilitation of Payment Initiation Services (PIS) and Account Information Services (AIS) through the use of a third-party providers.
                    </p>
                    <p>
                      Sunlex only provides technical solutions related to the AIS and PIS. Sunlex in no way shall be treated as a PIS or AIS direct provider. For that purpose, Sunlex uses the services of a third parties licensed under the Payment Services Directive (PSD2) who are the AIS and PIS sole providers. Sunlex only ensures the technical convergence between the Payment Service User and the AIS and/or PIS third party service providers.
                    </p>
                    <p>
                      In order for the Merchant to have access to the services provided by Sunlex, the Merchant agrees and acknowledges its understanding of these Terms and Conditions, which shall, along with the Merchant Application Form and the Merchant Services Agreement, be legally binding on the Merchant.
                    </p>
                    <p>
                      We reserve the right to change and update the Terms set forth herein, and any updated version will be published on the website https://www.sunlex.net.
                    </p>
                    <p>
                      If you do not agree to any part of our Terms, please do not use our services. If you continue to use our services after the amendments, we will consider these actions as your acknowledgement and agreement to our terms. By continuing you will be entering into these Terms and will be bound by them.
                    </p>
                    <p>
                      The Merchant undertakes to comply with these Terms and Conditions.
                    </p>
                </div>
                <div className='support-article-wrap'>
                    <h4 className='h5 padding-top-5 padding-bottom-4'>
                      2. Definitions
                    </h4>
                    <p>
                      "Agreement" means the present Terms and Conditions, the Merchant Application Form and the Merchant Services Agreement;
                    </p>
                    <p>
                      "Payment Services Directive II" or "PSD2" means Directive (EU) 2015/2366 of the European Parliament and of the Council of 25 November 2015 on payment services in the internal market, amending Directives 2002/65/EC, 2009/110/EC and 2013/36/EU and Regulation (EU) No 1093/2010, and repealing Directive 2007/64/EC;
                    </p>
                    <p>
                      "Account Information Service" or "AIS" means an online service to provide consolidated information on one or more Payment Accounts held by the Payment Service User with one or more bank;
                    </p>
                    <p>
                      "Payment Initiation Service" means a service to initiate a payment order at the request of the payment service user with respect to a payment account held at financial institution;
                    </p>
                    <p>
                      "Merchant" means legal entity that is providing services or selling goods online;
                    </p>
                    <p>
                      "Merchant end user" means the natural person who uses the services of Sunlex through the Merchant as a payment method ;
                    </p>
                    <p>
                      "Party" means each party under the Agreement;
                    </p>
                    <p>
                      "Payer" means a natural person who holds a payment account and allows a payment order from that payment account, or, where there is no payment account, a natural person who gives a payment order;
                    </p>
                    <p>
                      "Payment Account" means an account held in the name of one or more payment service users which is used for the execution of payment transactions;
                    </p>
                    <p>
                      "Payment Order" means an instruction by a payer or payee to its payment service provider requesting the execution of a payment transaction;
                    </p>
                    <p>
                      "Payment Service" means any business activity set out in the PSD2;
                    </p>
                    <p>
                      "Financial institution" means credit institutions as defined in point (1) of Article 4(1) of Regulation (EU) No 575/2013, investment firms as defined in point (2) of Article 4(1) of Regulation (EU) No 575/2013, financial conglomerates as defined in Article 2(14) of Directive 2002/87/EC, payment service providers as defined in point (11) of Article 4 of Directive (EU) 2015/2366 and electronic money institutions as defined in point (1) of Article 2 of Directive 2009/110/EC, save that, with regard to Directive (EU) 2015/849, ‘financial institutions’ means credit institutions and financial institutions as defined in points (1) and (2) of Article 3 of Directive (EU) 2015/849;
                    </p>
                    <p>
                      "Payment Service User" means a natural or legal person making use of a payment service in the capacity of payer, payee, or both;
                    </p>
                    <p>
                      "Personalised Security Credentials" means personalised features provided by the Payment Service Provider to a Payment Service User for the purposes of authentication;
                    </p>
                </div>
                <div className='support-article-wrap'>
                    <h4 className='h5 padding-top-5 padding-bottom-4'>
                      3. Merchant Account
                    </h4>
                    <p>
                      The completion of certain documents may be required from the Merchant along with the provision of proof of identity in accordance with the law and Sunlex's internal AML/CFT procedures.
                    </p>
                    <p>
                      Additional information and/or documents relating to the Merchant or to the transactions carried out by the Merchant may be requested by Sunlex. Furthermore, Sunlex reserves the right to require the Merchant or its representative to complete the "Know Your Customer" questionnaire periodically.
                    </p>
                    <p>
                      The Merchant shall, upon request, provide copies of the documents certified by a notary public and/or translated into English at their own expense. Refusal to provide the required documents within a reasonable time, as determined by Sunlex, may result in the suspension of access to all or part of the Services provided to the Merchant.
                    </p>
                    <p>
                      In the course of the performance of the Services, Sunlex may transfer some personal data to a third party, and such third party independently determines the purposes and means of processing of the Information so transferred. Sunlex and such third party are therefore a separate data controller of such data in terms of European Union General Data Protection Regulation No 2016/679 (GDPR). The processing of such information will be in accordance with the terms and conditions of our Privacy Policy.
                    </p>
                    <p>
                      By registering to use our services, as a legal representative of the Merchant, you confirm:
                    </p>
                    <ul className='content-list list-unstyled'>
                        <li>
                           that the information provided is correct and the data that have been provided relates to you and the Merchant;
                        </li>
                        <li>
                           you are not acting on behalf of anyone else but the specified Merchant;
                        </li>
                        <li>
                           you have the right to enter into a legally binding agreement with us;
                        </li>
                        <li>
                           that You are 18 years old;
                        </li>
                        <li>
                           by agreeing to our Terms, you warrant that You will not use our Services for any fraudulent or unlawful purpose;
                        </li>
                        <li>
                           You are not a citizen or a resident of any country part of OLAF or EU EC, FATF sanctions list.
                        </li>
                      </ul>
                    <p>
                      Once the information you provide has been verified, your account will be activated.
                    </p>
                    <p>
                      Your account will not be activated if you have not provided all the information required in connection with due diligence and financial crime prevention requirements.
                    </p>
                    <p>
                      In the event that any information you have provided is subject to change in the future, you are required to notify us promptly, but no later than 5 business days from the date of the change.
                    </p>
                    <p>
                      We reserve the right to reject your application at our sole discretion.
                    </p>
                    <p>
                      A Merchant may only use the account for the purposes and management of his/her business.
                    </p>
                    <p>
                      Access to the Merchant's account must not be granted to third parties. In the event that the Merchant has granted access to his/her account to a third party, the Merchant shall be liable for any transaction conducted by the third party.
                    </p>

                </div>
                <div className='support-article-wrap'>
                    <h4 className='h5 padding-top-5 padding-bottom-4'>
                      4. Our Services
                    </h4>
                    <p>
                      The services (“Services”) We offer that might be provided directly or via the use of a a third-party service provider are as follows:
                    </p>

                    <ul className='content-list list-unstyled'>
                        <li>
                           Access to the open banking API in accordance with the API documentation to retrieve information about the Merchant end users' accounts for the purpose of providing the Merchant's services to end users
                        </li>
                        <li>
                           Account Information Service
                        </li>
                        <li>
                           Payment Initiation Services
                        </li>
                        <li>
                           Aggregating account information from financial institutions in accordance with the end user's instructions and provision of account information to a third party
                        </li>
                      </ul>
                    <p>
                      For avoidance of doubt, Sunlex is acting as a technical provider by enabling You through our technical solutions to use via a third-party partner to Sunlex the services as per below:
                    </p>
                    <ul className='content-list list-unstyled'>
                        <li>
                           Money transfers
                        </li>
                        <li>
                           Account Information Service
                        </li>
                        <li>
                           Payment Initiation Services
                        </li>
                        <li>
                           Virtual IBANs
                        </li>
                      </ul>
                    <p>
                      In order for the Payment Service User to benefit from the Account Information Services, it is necessary, firstly, to give consent to Sunlex; secondly, by using an authentication method provided by the Financial institution, to connect to e-banking and an explicit consent to be provided to access payment account information.
                    </p>
                    <p>
                      Electronic means shall be used to obtain consent from the User of the Company's Payment services and shall only be used once during a session until the Payment Service User has been provided with an extract of the data.
                    </p>
                    <p>
                      Sunlex shall technically facilitate account to account payment to a Payment account opened with the Financial institution servicing the account after obtaining express consent to do so from the Merchant end user (the „Payer“).
                    </p>
                    <p>
                      In order for the Payer to be forwarded to the Financial institution and a payment to be processed, it is necessary for the Payer to enter Personalised Security Credentials using the authorisation method provided by the Financial institution where the Payer holds a Payment Account.
                    </p>
                    <p>
                      Once the personalised security credentials have been entered, the Payer must again provide consent to Sunlex in order to proceed with sending the Payment Order to the Financial institution servicing Payer‘s account for execution. The Financial institution sends information to Sunlex as to whether the Payment Instruction has been accepted and, where requested, Sunlex transmits this information to the final beneficiary specified by the Payer;
                    </p>
                    <p>
                      The personalised security credentials entered are encrypted and used only to initiate payment once during a session. The session is valid only until payment confirmation is received from the Financial institution servicing the account.
                    </p>
                    <p>
                      Cancellation of the Service may be initiated at any time prior to the provision of consent regarding the initiation of the relevant payment.
                    </p>
                    <p>
                      Sunlex reserves the right, at its sole discretion, to verify the identity of the Payer before proceeding to send the Payment Order to the Financial institution.
                    </p>
                    <p>
                      Sunlex ensures that all necessary measures are taken to ensure the security and non-disclosure of the data received.
                    </p>
                    <p>
                      Sunlex does not collect or process sensitive data related to the Payer.
                    </p>
                    <p>
                      We only request and process data that is necessary for the provision of our Service, except where this would be contrary to applicable law.
                    </p>
                    <p>
                      Sunlex is entitled to enter into contractual relations with third party providers to provide the Services to the Merchant.
                    </p>
                </div>
                <div className='support-article-wrap'>
                    <h4 className='h5 padding-top-5 padding-bottom-4'>
                      5. Liability
                    </h4>
                    <p>
                      We shall only be liable in the event that we breach our obligations under these Тerms and Conditions.
                    </p>
                    <p>
                      We shall not be liable for any loss or damage that was unforeseeable or for any indirect or consequential loss (including loss of profit, loss of revenue or financial loss) that results from Merchant’s acts or omissions. In the event of abuse of rights or misuse of the Services provided by us in any way by the Merchant, We reserve our inalienable right to take restrictive measures, including but not limited to restricting that Merchant User's access to our services. We are not responsible for any use of or reliance on the Services, the content of the Services, or the output of the Services.
                    </p>
                    <p>
                      We shall not be liable in the event of inability to benefit from the Services due to a cause beyond our control.
                    </p>
                    <p>
                      We have no control over the data that is maintained by the Financial institutions for the servicing of accounts, and no warranty is given as to the quality of the data in the Account Information Service or that it is accurate or complete.
                    </p>
                    <p>
                      The responsibility for the performance of its own services and the guarantee that they comply with legal requirements rests entirely with the respective Merchant. Sunlex is not responsible for their obligations and the quality of the performance of their services.
                    </p>
                    <p>
                      You shall be liable for all damages and losses that are caused as a result of its acts or omissions.
                    </p>
                    <p>
                      In the event that suspicious activity is detected and a security breach is suspected, the services offered to the Merchant will be suspended until the circumstances are determined. In such cases, the Merchant will be notified.
                    </p>
                    <p>
                      Sunlex shall be exempt from liability in the event of a partial or full failure to comply with its obligations under these Terms and Conditions, where such failure is the consequence of force majeure circumstances which are not our fault and which make it objectively impossible for us to perform our obligations. For the avoidance of doubt, natural disasters, pandemics, fires, wars, blockades, general strikes, prohibitions by governmental authorities are considered force majeure.
                    </p>
                    <p>
                      The Merchant shall indemnify, defend and hold Sunlex harmless, its officers, agents, consultant(s), employees and affiliates from and against any and all claims, damages, liabilities, costs, losses, expenses (including attorney’s fees), liens, demands and causes of action of any kind or character, including, without limitation, the amount of any judgement, penalty, interest charge, and fee to the extent that such claims, costs or expenses arise out of any breach of these Terms by Sunlex, or have arisen out of, been caused by or to be in connection with any of Sunlex’s services and work or duties hereunder or any act or omission of Sunlex and/or its agents and employees.
                    </p>
                    <p>
                      The Merchant agrees to indemnify and hold us harmless from and against any and all losses, damages, reasonable costs and expenses or penalties that we may suffer or incur arising out of or in connection with Merchant’s making illegally initiated payments from your Payment account.
                    </p>
                </div>
                <div className='support-article-wrap'>
                    <h4 className='h5 padding-top-5 padding-bottom-4'>
                      6. Intellectual Property
                    </h4>
                    <p>
                      Sunlex website and services are subject to intellectual property rights, accordingly they feature and incorporate elements that are protected by the applicable intellectual property regulatory framework. These elements belong to Sunlex, unless otherwise expressly stated, and include, but are not limited to, logos, trademarks, domain names, databases, code, graphic design, etc. The use of any part of the intellectual property of Sunlex without the express prior consent of the latter is prohibited.
                    </p>
                    <p>
                      We reserve the right to take all necessary action against infringement of its intellectual property.
                    </p>
                    <p>
                      No rights are granted to the user other than those set out in these Terms.
                    </p>
                </div>
                <div className='support-article-wrap'>
                    <h4 className='h5 padding-top-5 padding-bottom-4'>
                      7. Advertisement
                    </h4>
                    <p>
                      The Merchant acknowledges and agrees that any trademarks, trade names, designs, logos, and all other intellectual property provided to the Merchant by Sunlex may be used by the Merchant solely in connection with Merchant advertising and promotion of the acceptance of Sunlex services as a payment method.
                    </p>
                    <p>
                      Each marketing campaign related to the use of Sunlex as a payment method must be approved by Sunlex prior to its initiation.
                    </p>
                    <p>
                      The Merchant undertakes that the marketing campaigns will not contain any content that would damage the good name and reputation of Sunlex and that all information related to the services offered by the latter will be correct, clear and not misleading to the Merchant’s end user.
                    </p>
                    <p>
                      The Merchant shall be liable in the event that Sunlex suffers any direct, indirect or consequential loss (including loss of profit, loss of revenue or financial loss) due to any of the marketing campaigns launched by the Merchant.
                    </p>
                </div>
                <div className='support-article-wrap'>
                    <h4 className='h5 padding-top-5 padding-bottom-4'>
                      8. Personal Data
                    </h4>
                    <p>
                      To read the information on the protection and processing of personal data, see the Privacy Policy here.
                    </p>
                </div>
                <div className='support-article-wrap'>
                    <h4 className='h5 padding-top-5 padding-bottom-4'>
                      9. Use of Cookies
                    </h4>
                    <p>
                      You can read our Cookie Policy here.
                    </p>
                </div>
                <div className='support-article-wrap'>
                    <h4 className='h5 padding-top-5 padding-bottom-4'>
                      10. Confidentiality
                    </h4>
                    <p>
                      You agree that the Terms and Conditions agreed upon hereunder and any information received during the validity of these Terms represents confidential information ("Confidential Information") to be used only and solely for the purpose of performing the subject matter hereof by the parties hereto.
                    </p>
                    <p>
                      During the validity of these Terms and after its termination, You shall not directly or indirectly disclose such Confidential Information to any third party without the consent of Sunlex, except as otherwise provided in a separate agreement to which Sunlex is a party.
                    </p>
                    <p>
                      Confidential Information means any information and/or data that is proprietary to Sunlex and is not generally known to the public.
                    </p>
                </div>
                <div className='support-article-wrap'>
                    <h4 className='h5 padding-top-5 padding-bottom-4'>
                      11. Termination
                    </h4>
                    <p>
                      These Terms and Conditions will remain in effect until the Merchant terminates the account and ceases using the Services provided by Sunlex.
                    </p>
                    <p>
                      The Merchant can terminate the Agreement by providing 30(thirty) days written notice.
                    </p>
                    <p>
                      Sunlex can terminate the Agreement at its discretion at any time without prior notice. Should this be the case, the Merchant will be notified about the termination.
                    </p>
                    <p>
                      Sunlex may terminate the Agreement immediately by written notice herein if the Merchant materially defaults in the performance of any of its obligations and covenants or materially breaches any of its representations and warranties set forth in the Agreement, and fails to cure such default or breach within thirty (30) days of written notice by Sunlex.
                    </p>
                    <p>
                      The Agreement can be terminated by either party if the other party is involved in any legal proceedings concerning its solvency, or ceases trading, or commits an act of bankruptcy or is adjudicated bankrupt or enters into liquidation, whether voluntary or compulsory, other than for the purposes of an amalgamation or reconstruction, or makes an arrangement with its creditors or petitions for an administration order or has a receiver or manager appointed over all or any part of its assets or becomes unable to pay its debts or anything analogous to such event occurs according to the relevant existing jurisdiction.
                    </p>
                </div>
                <div className='support-article-wrap'>
                    <h4 className='h5 padding-top-5 padding-bottom-4'>
                      12. Force Majeure
                    </h4>
                    <p>
                      The Parties shall not be liable for partial or total non-performance of their obligations under the Agreement in the event of force majeure occurring after the Agreement has entered into force, through no fault of the Party invoking them, and which makes it objectively impossible to perform its obligations. Natural disasters, fires, war, blockades, general strikes, prohibitions by public authorities are to be treated as force majeure.
                    </p>
                    <p>
                      The party invoking force majeure shall not be liable for failure to perform its obligations if it informs the other party by fax, e-mail or other means within ten days of the date of the incident and confirms the occurrence of the incident by a document issued by a representative Chamber of Commerce or other competent governmental authority proving a causal link between the incident and the impossibility of performing the contractual obligation. In the same manner and within the same time limits, the Party claiming force majeure shall inform the other Party of its termination.
                    </p>
                    <p>
                      Failure to perform an obligation due to force majeure shall be grounds for the other Party to postpone performance of its obligations until the Party invoking force majeure has fulfilled its obligations.
                    </p>
                    <p>
                      If the Force Majeure Event continues for more than three months, the other Party shall have the right to terminate the Agreement in whole or in part (at its discretion) by written notice by registered post without recourse to court or arbitration. The Party invoking force majeure shall not be entitled to terminate the Agreement on this ground.
                    </p>
                </div>
                <div className='support-article-wrap'>
                    <h4 className='h5 padding-top-5 padding-bottom-4'>
                      13. General
                    </h4>
                    <p>
                      The Merchant is not entitled to assign its rights and obligations under the Agreement to third parties.
                    </p>
                    <p>
                      The parties agree that nothing in the Agreement shall be construed as creating a joint venture, partnership, franchise, agency, employer/employee, or similar relationship between the parties, or as authorising either party to act as the agent of the other.
                    </p>
                    <p>
                      The contact details provided by you, such as email and telephone number, shall be used as a means of contact to inform you on any matter relating to the Services.
                    </p>
                    <p>
                      If you have any questions, please contact us by email at contact@sunlex.net.
                    </p>
                    <p>
                      Invalidation of individual clauses would not invalidate the entire Terms. The invalid clause should be replaced by another such provision, and if no agreement is reached, the same is superseded as of right by the mandatory rule of law, to the extent that there is one.
                    </p>
                    <p>
                      All disputes shall be settled by negotiation and in an amicable manner. In the event that a mutually acceptable agreement is not reached, all disputes arising out of or relating to the use of the Services shall be resolved by a Bulgarian court of competent jurisdiction under applicable Bulgarian law.
                    </p>
                    <p>
                      Sunlex reserves the right to change these Terms and Conditions, and any updated version will be posted on the www.sunlex.net website
                    </p>
                </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default MerchantTermsAndConditionsDetails;
